// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalLocationAddressRequirementsPhrase: MarkdocTagRegistration = {
  tag: 'terminal-location-address-requirements-phrase',
  component: 'TerminalLocationAddressRequirementsPhrase',
  attributes: {
    addressRequirementsByCountry: {
      type: Object,
      required: true,
      localizable: false,
      description:
        'Location validation requirements for countries from the terminal context',
    },
    country: {
      type: String,
      required: true,
      localizable: false,
      description:
        'Country code for which to show Location validation requirements',
    },
  },
};
